export default __webpack_public_path__ + "static/media/KidcoGrillGuide3.43ffd44d.jpg";